export default "<app-my-component></app-my-component>\n";